import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "social-twitch",
  "use": "social-twitch-usage",
  "viewBox": "0 0 17 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 20\" id=\"social-twitch\">\n    <path d=\"M17 0v11.605l-6.225 6.42H7.423L5.507 20H3.592v-1.975H.022L0 3.21.958 0H17zm-1.126 1.516H2.944V13.12h3.592v2.47l2.394-2.47h4.31l2.634-2.716V1.516zm-3.156 3.788v4.939h-1.676V5.304h1.676zm-4.417 0v4.939H6.625V5.304h1.676z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol